import { formatAgeSec } from '@ijoin/components';
import { QueueRes } from '@ijoin/hooks';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  Card,
  CardContent,
  IconButton,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';

type Props = {
  queue: QueueRes;
};

export const QueueDetailHeader = ({ queue }: Props) => (
  <Card sx={{ p: 1 }}>
    <CardContent>
      <Stack direction='row' spacing={3} sx={{ flexWrap: 'wrap' }}>
        <div>
          <Typography color='text.secondary' variant='overline'>
            Name
          </Typography>
          <Typography variant='h5'>{queue.name}</Typography>
        </div>
        <div>
          <Stack alignItems='center' direction='row'>
            <Typography color='text.secondary' variant='overline'>
              Messages
            </Typography>
            <Tooltip arrow title='Visible messages waiting in the queue.'>
              <IconButton>
                <InfoOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Stack>
          <Typography variant='h6'>{queue.messages}</Typography>
        </div>
        <div>
          <Stack alignItems='center' direction='row'>
            <Typography color='text.secondary' variant='overline'>
              In Flight
            </Typography>
            <Tooltip
              arrow
              title='Messages received by a consumer but not yet acked or expired.'>
              <IconButton>
                <InfoOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Stack>
          <Typography variant='h6'>{queue.inFlight}</Typography>
        </div>
        <div>
          <Stack alignItems='center' direction='row'>
            <Typography color='text.secondary' variant='overline'>
              Delayed
            </Typography>
            <Tooltip arrow title='Messages scheduled to become visible later.'>
              <IconButton>
                <InfoOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Stack>
          <Typography variant='h6'>{queue.delayed}</Typography>
        </div>
        <div>
          <Stack alignItems='center' direction='row'>
            <Typography color='text.secondary' variant='overline'>
              Oldest Age
            </Typography>
            <Tooltip
              arrow
              title='Age of the oldest visible message. Rises when consumers cannot keep up.'>
              <IconButton>
                <InfoOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Stack>
          <Typography variant='h6'>
            {formatAgeSec(queue.oldestMessageAgeSec)}
          </Typography>
        </div>
        <div>
          <Stack alignItems='center' direction='row'>
            <Typography color='text.secondary' variant='overline'>
              Visibility Timeout
            </Typography>
            <Tooltip
              arrow
              title='How long a received message stays hidden from other consumers before reappearing.'>
              <IconButton>
                <InfoOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Stack>
          <Typography variant='h6'>{queue.visibilityTimeout}s</Typography>
        </div>
        <div>
          <Stack alignItems='center' direction='row'>
            <Typography color='text.secondary' variant='overline'>
              FIFO
            </Typography>
            <Tooltip
              arrow
              title='Whether the queue preserves message order (.fifo suffix).'>
              <IconButton>
                <InfoOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Stack>
          <Typography variant='h6'>{queue.isFifo ? 'Yes' : 'No'}</Typography>
        </div>
      </Stack>
    </CardContent>
  </Card>
);
